import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { object, func } from "prop-types";
import { SketchPicker } from "react-color";
import config from "../config";

import { updateVideo } from "../actions";

import { uploadFile } from "../utils/uploadFile";
import { create } from "../utils/apiService";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

class BrandChannel extends Component {
  constructor() {
    super();

    this.state = {
      brand_channel: {
        header_color: "",
        title_color: "",
        title: "",
        description: "",
        logo: "",
        banner: "",
        background: "",
        video_name: "",
        client_name: "",
        video_id: "",
        campaign_id: "",
        expirated_html: ""
      },
      pickers: {
        header: false,
        title: false
      },
      error: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
  }
  componentDidMount() {
    if (this.props.video.brand_channel === null) {
      this.setState({
        brand_channel: {
          ...this.state.brand_channel,
          video_id: this.props.video.id,
          campaign_id: this.props.video.campaign_id
        }
      });
    } else {
      this.setState({
        brand_channel: this.props.video.brand_channel
      });
    }
  }
  handleChange(e) {
    this.setState({
      brand_channel: {
        ...this.state.brand_channel,
        [e.target.name]: e.target.value
      }
    });
  }
  handleDescriptionChange(value) {
    this.setState({
      brand_channel: {
        ...this.state.brand_channel,
        description: value
      }
    });
  }
  handleFileChange(type, file) {
    const { video } = this.props;
    if (file) {
      uploadFile(file, video).then(res => {
        let fileUrl = res;
        this.setState({
          brand_channel: {
            ...this.state.brand_channel,
            [type]: fileUrl
          }
        });
      });
    } else {
      toastr.error("Nenhum arquivo para fazer upload");
    }
  }
  submitForm() {
    if (this.isFormValid()) {
      const { video, updateVideo } = this.props;
      let url = `/campaigns/${video.campaign_id}/videos/${
        video.id
      }/brand_channels`;
      create(url, {
        brand_channel: this.state.brand_channel
      })
        .then(res => {
          let updatedVideo = res.data;
          updateVideo(video.campaign_id, updatedVideo);
          toastr.success("Brand Channel criado/atualizado com sucesso");
        })
        .catch(err => {
          toastr.error("Ocorreu um erro. Tente novamente");
        });
    }
  }
  isFormValid() {
    for (var key in this.state.brand_channel) {
      if (this.state.brand_channel.hasOwnProperty(key)) {
        if (this.state.brand_channel[key] === "" && key !== "background") {
          this.setState({
            error: "Todos os campos devem ser preenchidos."
          });
          return false;
        }
      }
    }
    this.setState({
      error: ""
    });
    return true;
  }
  render() {
    const { campaign, video } = this.props;
    let bc = this.state.brand_channel;
    // Picker styles
    const popover = {
      position: "absolute",
      zIndex: "2"
    };
    const cover = {
      position: "fixed",
      top: "0px",
      right: "0px",
      bottom: "0px",
      left: "0px"
    };
    var modules = {
      toolbar: [
        [{ font: [] }, { size: [] }],
        [{ align: [] }, "direction"],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ script: "super" }, { script: "sub" }],
        ["blockquote", "code-block"],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" }
        ],
        ["link", "image", "video"],
        ["clean"]
      ]
    };
    return (
      <Grid>
        <Row>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Cor do Header</ControlLabel>
              <div
                style={{
                  display: "inline-block",
                  marginLeft: 10,
                  height: 10,
                  width: 20,
                  backgroundColor: this.state.brand_channel.header_color
                }}
              />
              <FormControl
                name="header_color"
                type="text"
                value={bc.header_color}
                placeholder="Cor do header"
                onChange={this.handleChange}
                onFocus={() => {
                  this.setState({ pickers: { header: true, title: false } });
                }}
              />
            </FormGroup>
            {this.state.pickers.header ? (
              <div style={popover}>
                <div
                  style={cover}
                  onClick={() => {
                    this.setState({ pickers: { header: false, title: false } });
                  }}
                />
                <SketchPicker
                  color={this.state.brand_channel.header_color}
                  onChangeComplete={color => {
                    this.setState({
                      brand_channel: {
                        ...this.state.brand_channel,
                        header_color: color.hex
                      }
                    });
                  }}
                />
              </div>
            ) : null}
          </Col>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Cor do Título</ControlLabel>
              <div
                style={{
                  display: "inline-block",
                  marginLeft: 10,
                  height: 10,
                  width: 20,
                  backgroundColor: this.state.brand_channel.title_color
                }}
              />
              <FormControl
                name="title_color"
                type="text"
                value={bc.title_color}
                placeholder="Cor do título"
                onChange={this.handleChange}
                onFocus={() => {
                  this.setState({ pickers: { header: false, title: true } });
                }}
              />
            </FormGroup>
            {this.state.pickers.title ? (
              <div style={popover}>
                <div
                  style={cover}
                  onClick={() => {
                    this.setState({ pickers: { header: false, title: false } });
                  }}
                />
                <SketchPicker
                  color={this.state.brand_channel.title_color}
                  onChangeComplete={color => {
                    this.setState({
                      brand_channel: {
                        ...this.state.brand_channel,
                        title_color: color.hex
                      }
                    });
                  }}
                />
              </div>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <ControlLabel>Título</ControlLabel>
              <FormControl
                name="title"
                type="text"
                value={bc.title}
                placeholder="Título do vídeo"
                onChange={this.handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <ControlLabel>Descrição</ControlLabel>
              {/* <FormControl
                componentClass="textarea"
                name="description"
                value={bc.description}
                placeholder="Descrição do vídeo"
                onChange={this.handleChange}
              /> */}
              <ReactQuill
                value={bc.description}
                onChange={this.handleDescriptionChange}
                modules={modules}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Imagem da Logo</ControlLabel>
              <div className="mb10">
                <img
                  src={this.state.brand_channel.logo}
                  alt="Brand Channel Logo"
                />
              </div>
              <input
                name="logo"
                className="form-control"
                type="file"
                ref={input => {
                  this.logoFileInput = input;
                }}
                onChange={() => {
                  this.handleFileChange("logo", this.logoFileInput.files[0]);
                }}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Imagem do Banner</ControlLabel>
              <div className="mb10">
                <img
                  src={this.state.brand_channel.banner}
                  alt="Brand Channel Banner"
                />
              </div>
              <input
                name="banner"
                className="form-control"
                type="file"
                ref={input => {
                  this.bannerFileInput = input;
                }}
                onChange={() => {
                  this.handleFileChange(
                    "banner",
                    this.bannerFileInput.files[0]
                  );
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <ControlLabel>Imagem do BG</ControlLabel>
              {this.state.brand_channel.background !== "" && (
                <div style={{ position: "relative" }} className="mb10">
                  <img
                    style={{ maxWidth: "30%" }}
                    src={this.state.brand_channel.background}
                    alt="Brand Channel Background"
                  />
                  <button
                    style={{ position: "absolute", top: "2%", left: "1%" }}
                    onClick={() =>
                      this.setState({
                        brand_channel: {
                          ...this.state.brand_channel,
                          background: ""
                        }
                      })
                    }
                  >
                    Remover BG
                  </button>
                </div>
              )}
              <input
                name="background"
                className="form-control"
                type="file"
                ref={input => {
                  this.backgroundFileInput = input;
                }}
                onChange={() => {
                  this.handleFileChange(
                    "background",
                    this.backgroundFileInput.files[0]
                  );
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <ControlLabel>HTML para URL Expirada</ControlLabel>
              <FormControl
                componentClass="textarea"
                name="expirated_html"
                value={bc.expirated_html}
                placeholder="Esse vídeo expirou!"
                onChange={this.handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Nome do Cliente</ControlLabel>
              <FormControl
                type="text"
                name="client_name"
                value={bc.client_name}
                placeholder="Nome do cliente"
                onChange={this.handleChange}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Nome do Vídeo</ControlLabel>
              <FormControl
                type="text"
                name="video_name"
                value={bc.video_name}
                placeholder="Nome do vídeo"
                onChange={this.handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
        {this.state.error !== "" && (
          <Row>
            <Col md={12}>
              <h1>{this.state.error}</h1>
            </Col>
          </Row>
        )}
        <Row>
          <div className="pull-left">
            <a
              href={`http:${config.brandChannelApiUrl}/${
                this.state.brand_channel.client_name
              }/${this.state.brand_channel.video_name}?id=${
                video.default_brand_channel_session
              }`}
              target="_blank"
            >
              http:{config.brandChannelApiUrl}/{
                this.state.brand_channel.client_name
              }/{this.state.brand_channel.video_name}?id={
                video.default_brand_channel_session
              }
            </a>
            <br />
            <small>O link estará disponível somente após salvar</small>
          </div>
          <FormGroup className="mt20">
            <div className="pull-right ml10">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={this.submitForm}
              >
                Salvar
              </button>
            </div>
            <div className="pull-right">
              <Link
                className="btn btn-default"
                to={`/campaigns/${campaign.id}/videos`}
              >
                Voltar
              </Link>
            </div>
          </FormGroup>
        </Row>
      </Grid>
    );
  }
}

BrandChannel.propTypes = {
  video: object,
  updateVideo: func
};

const mapDispatchToProps = dispatch => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video));
  }
});

export default connect(null, mapDispatchToProps)(BrandChannel);



// WEBPACK FOOTER //
// ./src/components/BrandChannel.js